import React, { Component } from 'react';
import Title from './Title';
import { closeSummary, printSummary } from '../lib/functions';

class Summary extends Component {
    render() {

        const getMarks =  this.props.summary.length ? this.props.summary.map((data) => {
            return parseInt(data.markvalue)
        }).reduce((a, b) => {
            return a + b
        }) : "error"

 
    
        return (
            <div id="summary" className="summary" hidden>
                <div className="summary-header">
                    <div className="summary-close-icon"><i className="fa fa-times"></i></div>
                    <Title  className="summary-title" title={this.props.title}/>
                </div>
            <div className="summary-body">
            <div className="summary-subject-marks">
                <h2 className="summary-subject">{this.props.subjectTitle}</h2>
                <h3 className="summary-total-marks">{getMarks} total marks</h3>
            </div>
                               
                    {this.props.summary.length ? this.props.summary.slice(0, this.props.questionCount).map((item, index) => { 
                        return (
                            <div className="summary-container" key={index}>     
                            <div className="summary-des">
                                <h4>{index + 1}.</h4>
                                <h4>{item.des}</h4>
                            </div>
                            <div className="summary-topic">
                                <p className="summary-group">Topic</p>
                                <p>{item.ttext}</p>
                            </div>
                            <div className="summary-marks">
                                <p className="summary-group">Marks</p>
                                <p>{item.markvalue}</p>
                            </div>
                            <div className="summary-id">
                                <p className="summary-group">ID</p>
                                <p>{item.qid}</p>
                            </div>

                            </div>
                            )
                        }) : "error"}
    
            </div>
                <div className="summary-footer">
                    <div onClick={printSummary} className="menu-button summary-print">
                        <p>Print Summary</p>
                        <p><i className="fa fa-print"></i></p>
                    </div>
                    <div className="menu-button menu-cancel-button summary-close" onClick={closeSummary}>
                        <p className="menu-cancel">Close</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Summary